import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class militaryBaseGuideList_template extends vnTemplate {
    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="list-header w-justify">
                <div class="w-left">
                    <button data-bind="click: onClickAdd" class="btn secondary icon i-add" type="button">Add Military Base</button>
                </div>
                <div class="w-center">${this.filter.getHtmlBuild()}</div>
                <div class="w-right">${this.pagination.getHtmlBuild()}</div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Title</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'shortName') }, css: { 'list-sort-desc': orderByAndDirection()=='shortName_DESC', 'list-sort-asc': orderByAndDirection()=='shortName_ASC' }">Short Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'baseGroup') }, css: { 'list-sort-desc': orderByAndDirection()=='baseGroup_DESC', 'list-sort-asc': orderByAndDirection()=='baseGroup_ASC' }">Base Group</span></th>
                            <th><span>Status</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: bases">
                        <tr class="cursor" data-bind="event: { click: $parent.onClickView }">
                            <td><a class="right-click" data-bind="attr: { href: emakiView }, text: id"></a></td>
                            <td>
                                <a class="right-click" data-bind="attr: { href: emakiView }">
                                    <div class="flex">
                                        <span data-bind="text: title"></span>
                                        <button type="button" data-bind="visible: slug, event: { click: $parent.onClickViewOnSite }" class="btn icon border only-icon i-link"></button>
                                    </div>
                                </a>
                            </td>
                            <td data-bind="text: shortName"></td>
                            <td data-bind="text: baseGroup"></td>
                            <td data-bind="text: status ? 'Active' : 'Inactive'"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        `;
    }

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
    }

    protected getTemplateName(): string {
        return "militaryBaseGuideList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            idBrand: ko.observable(null),
            orderBy: ko.observable("title"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("title_ASC"),
            bases: ko.observableArray([]),
            onClickAdd: function () {
                self.caller.addBase();
            },
            onClickView: function (data, event) {
                self.caller.viewBase(data.id);
            },
            onClickViewOnSite: function (data, event) {
                return self.onClickViewOnSite(data, event);
            },
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            }
        };
    }

    public setIdBrand(idBrand): void {
        this.getTemplateViewModel().idBrand(idBrand);
    }

    public setBases(bases): void {
        const brandId = this.getTemplateViewModel().idBrand();
        bases.forEach((base) => base.emakiView = "/brand/" + brandId + "/military-base-guides/bases/view/" + base.id);
        this.getTemplateViewModel().bases(bases);
    }

    public getViewModelForRequest() {
        return {
            pagination: this.getTemplateViewModel().pagination,
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            filters: {
                keyword: this.getTemplateViewModel().filter.filterKeyword,
            },
        };
    }

    public setResultInfo(nbResults, nbPages, execTime): void {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    protected onClickReorder(value, data, event): void {
        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            data.orderByDirection(data.orderByDirection() == "DESC" ? "ASC" : "DESC");
        } else {
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.listReorder();
    }

    protected onClickViewOnSite(data, event): boolean {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.caller.viewBaseOnSite(data.slug);
        return false;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/militaryBaseGuideList_template.ts